<div id="contact-form">
  <form (submit)="onFormSubmit($event)">
    <dx-form
      id="form"
      class="form last plain-styled-form"
      validationGroup="projectData"
      [formData]="project()()"
      [showValidationSummary]="true"
      labelMode="floating"
      [(isDirty)]="isDirty"
      (onFieldDataChanged)="runValidation()">
      <!-- Form elements -->

      <dxi-item>
        <div *dxTemplate>
          <div class="refresh-button-container">
            <dx-button [icon]="'refresh'" class="refresh-button" (onClick)="onRefreshClicked()"></dx-button>
          </div>
        </div>
      </dxi-item>
      <dxi-item itemType="group" [colCount]="2">
        <dxi-item [colSpan]="2">
          <div style="width: 100%; border-top: 1px solid lightgray; margin: 10px 0"></div>
        </dxi-item>
        <dxi-item itemType="group">
          <dxi-item itemType="group" [colCount]="2"></dxi-item>
          <dxi-item itemType="group" [colCount]="2">
            <dxi-item dataField="ProjectNo" editorType="dxNumberBox" [editorOptions]="{ readOnly: true }">
              <dxo-label [text]="'PROJECT.ProjectNo' | translate"> </dxo-label>
            </dxi-item>

            <!-- States -->
            <dxi-item
              dataField="ProcessingState"
              editorType="dxSelectBox"
              [editorOptions]="{
                dataSource: ProcessingStateList,
                displayExpr: 'display',
                valueExpr: 'value',
                readOnly: !allowStateChange(),
              }">
              <dxo-label [text]="'PROJECT.ProcessingState' | translate"> </dxo-label>
            </dxi-item>
          </dxi-item>

          <dxi-item itemType="group" [colCount]="2">
            <dxi-item
              dataField="DriverState"
              editorType="dxSelectBox"
              [editorOptions]="{
                dataSource: DriverStateList,
                displayExpr: 'display',
                valueExpr: 'value',
                readOnly: true,
              }">
              <dxo-label [text]="'PROJECT.DriverState' | translate"> </dxo-label>
            </dxi-item>
            <dxi-item
              dataField="NotificationSend"
              editorType="dxSelectBox"
              [editorOptions]="{
                dataSource: NotificationStateList,
                displayExpr: 'display',
                valueExpr: 'value',
                readOnly: true,
              }">
              <dxo-label [text]="'PROJECT.NotificationSend' | translate"> </dxo-label>
            </dxi-item>
          </dxi-item>

          <dxi-item itemType="group" [colCount]="2">
            <!-- Vehicle -->
            <dxi-item
              dataField="VehicleId"
              editorType="dxSelectBox"
              [editorOptions]="{
                dataSource: VehicleList(),
                displayExpr: 'displayName',
                valueExpr: 'vehicleId',
                searchMode: 'contains',
                searchEnabled: true,
                readOnly: !allowVehicleChange(),
                onValueChanged: tryChangeDriver,
              }">
              <dxo-label [text]="'PROJECT.Vehicle' | translate"> </dxo-label>
              <dxi-validation-rule type="required" message="Vehicle is required"></dxi-validation-rule>
              <dxi-validation-rule
                type="custom"
                [validationCallback]="validateVehicle"
                [message]="'PROJECT_VALIDATION.VEHICLE_NOT_AVAILABLE' | translate">
              </dxi-validation-rule>
            </dxi-item>

            <!-- Driver -->
            <dxi-item
              name="Driver"
              dataField="DriverId"
              editorType="dxSelectBox"
              [editorOptions]="{
                dataSource: DriverList(),
                displayExpr: 'identifier',
                valueExpr: 'employeeNumber',
                searchMode: 'contains',
                searchEnabled: true,
                readOnly: !allowDriverChange(),
              }">
              <dxo-label [text]="'PROJECT.Driver' | translate"> </dxo-label>
              <dxi-validation-rule type="required" message="Driver is required"></dxi-validation-rule>
              <dxi-validation-rule
                type="custom"
                [validationCallback]="validateDriver"
                [message]="'PROJECT_VALIDATION.DRIVER_NOT_AVAILABLE' | translate">
              </dxi-validation-rule>
            </dxi-item>
          </dxi-item>

          <!-- Prio -->
          <dxi-item itemType="group" [colCount]="2">
            <dxi-item
              dataField="Priority"
              editorType="dxNumberBox"
              [editorOptions]="{ showSpinButtons: true, readOnly: !allowEdit(), min: 1, max: 10 }">
              <dxo-label [text]="'PROJECT.Priority' | translate"> </dxo-label>
            </dxi-item>
            <dxi-item dataField="RampNeeded" editorType="dxCheckBox" [editorOptions]="{ readOnly: !allowEdit() }">
              <dxo-label [text]="'PROJECT.RampNeeded' | translate"> </dxo-label>
            </dxi-item>
            <dxi-item><!-- placeholder --></dxi-item>
            <dxi-item dataField="TunnelCode" editorType="dxCheckBox" [editorOptions]="{ readOnly: !allowEdit() }">
              <dxo-label [text]="'PROJECT.TunnelCode' | translate"> </dxo-label>
            </dxi-item>
          </dxi-item>

          <dxi-item itemType="group" [colCount]="2">
            <dxi-item dataField="AdrPoints" editorType="dxNumberBox" [editorOptions]="{ readOnly: true }">
              <dxo-label [text]="'PROJECT_DETAIL.AdrPoints' | translate"> </dxo-label>
            </dxi-item>
          </dxi-item>

          <!-- Date -->
          <dxi-item itemType="group" [colCount]="2">
            <dxi-item
              dataField="FromDateTime"
              editorType="dxDateBox"
              [editorOptions]="{ type: 'date', readOnly: !allowEdit(), onValueChanged: loadSelectionData }">
              <dxi-validation-rule
                type="required"
                [message]="'PROJECT_VALIDATION.DATETIME_REQUIRED' | translate"></dxi-validation-rule>
              <dxi-validation-rule
                type="custom"
                [validationCallback]="validateFromDate"
                [message]="'PROJECT_VALIDATION.DATERANGE_IMPOSSIBLE' | translate">
              </dxi-validation-rule>
              <dxo-label [text]="'PROJECT.FromDateTime' | translate"> </dxo-label>
            </dxi-item>
            <dxi-item
              dataField="UntilDateTime"
              editorType="dxDateBox"
              [editorOptions]="{ type: 'date', readOnly: !allowUntilDateChange(), onValueChanged: loadSelectionData }">
              <dxi-validation-rule
                type="required"
                [message]="'PROJECT_VALIDATION.DATETIME_REQUIRED' | translate"></dxi-validation-rule>
              <dxi-validation-rule
                type="custom"
                [validationCallback]="validateUntilDate"
                [message]="'PROJECT_VALIDATION.DATERANGE_IMPOSSIBLE' | translate">
              </dxi-validation-rule>
              <dxo-label [text]="'PROJECT.UntilDateTime' | translate"> </dxo-label>
            </dxi-item>
          </dxi-item>

          <!-- Time -->
          <dxi-item itemType="group" [colCount]="2">
            <dxi-item
              dataField="FromDateTime"
              editorType="dxDateBox"
              [editorOptions]="{ type: 'time', readOnly: !allowEdit(), onValueChanged: loadSelectionData }">
              <dxo-label [text]="'PROJECT.FromDateTime' | translate"> </dxo-label>
            </dxi-item>
            <dxi-item
              dataField="UntilDateTime"
              editorType="dxDateBox"
              [editorOptions]="{ type: 'time', readOnly: !allowUntilDateChange(), onValueChanged: loadSelectionData }">
              <dxo-label [text]="'PROJECT.UntilDateTime' | translate"> </dxo-label>
            </dxi-item>
          </dxi-item>

          <!-- Admin -->
          <dxi-item itemType="group" [colCount]="2">
            <dxi-item
              dataField="Administrator"
              editorType="dxSelectBox"
              [editorOptions]="{
                dataSource: AdminList(),
                displayExpr: 'identifier',
                valueExpr: 'identifier',
                searchMode: 'contains',
                searchEnabled: true,
                readOnly: !allowEdit(),
              }">
              <dxo-label [text]="'PROJECT_DETAIL.Administrator' | translate"> </dxo-label>
            </dxi-item>
          </dxi-item>

          <!-- Spacing -->
          <dxi-item itemType="empty" [height]="30" [colSpan]="2"> </dxi-item>

          <dxi-item itemType="group" [colCount]="2">
            <dxi-item dataField="CreatedBy" editorType="dxTextBox" [editorOptions]="{ readOnly: true }">
              <dxo-label [text]="'PROJECT.CreatedBy' | translate"> </dxo-label>
            </dxi-item>

            <dxi-item dataField="CreatedDateTime" editorType="dxDateBox" [editorOptions]="{ readOnly: true }">
              <dxo-label [text]="'PROJECT.CreatedDateTime' | translate"> </dxo-label>
            </dxi-item>
          </dxi-item>

          <dxi-item itemType="group" [colCount]="2">
            <dxi-item dataField="ChangedBy" editorType="dxTextBox" [editorOptions]="{ readOnly: true }">
              <dxo-label [text]="'PROJECT.ChangedBy' | translate"> </dxo-label>
            </dxi-item>

            <dxi-item dataField="ChangedDateTime" editorType="dxDateBox" [editorOptions]="{ readOnly: true }">
              <dxo-label [text]="'PROJECT.ChangedDateTime' | translate"> </dxo-label>
            </dxi-item>
          </dxi-item>
          <!-- Spacing -->
          <dxi-item itemType="empty" [height]="30" [colSpan]="2"> </dxi-item>

          <!-- Buttons -->
          @if (isDirty) {
            <dxi-item itemType="group" [colCount]="2">
              <dxi-item>
                <div *dxTemplate>
                  <dx-button [text]="'BUTTONS.DISCARD' | translate" (onClick)="discardChanges()"></dx-button>
                </div>
              </dxi-item>
            </dxi-item>
            <dxi-item itemType="group" [colCount]="2">
              <dxi-item>
                <div *dxTemplate>
                  <dx-button [text]="'BUTTONS.SAVE' | translate" [useSubmitBehavior]="true"></dx-button>
                </div>
              </dxi-item>
            </dxi-item>
            <dxi-item itemType="empty" [height]="30" [colSpan]="2"> </dxi-item>
          }
        </dxi-item>

        <!-- Right Side -->
        <dxi-item itemType="group">
          <dxi-item
            dataField="ProjectText"
            editorType="dxTextArea"
            [editorOptions]="{ autoResizeEnabled: true, heighmaxHeight: '130' }">
            <dxo-label [text]="'PROJECT.ProjectText' | translate"> </dxo-label>
          </dxi-item>
          <dxi-item
            dataField="DriverText"
            editorType="dxTextArea"
            [editorOptions]="{ autoResizeEnabled: true, maxHeight: '130' }">
            <dxo-label [text]="'PROJECT.DriverText' | translate"> </dxo-label>
          </dxi-item>
          <dxi-item
            dataField="StockText"
            editorType="dxTextArea"
            [editorOptions]="{ autoResizeEnabled: true, maxHeight: '130' }">
            <dxo-label [text]="'PROJECT.StockText' | translate"> </dxo-label>
          </dxi-item>
          <dxi-item
            dataField="Progression"
            editorType="dxTextArea"
            [editorOptions]="{ readOnly: true, autoResizeEnabled: true, height: '130' }">
            <dxo-label [text]="'PROJECT.Progression' | translate"> </dxo-label>
          </dxi-item>
        </dxi-item>
      </dxi-item>
    </dx-form>
  </form>
  <div class="outside-form">
    <dx-load-indicator class="load-indicator" [visible]="isLoading"> </dx-load-indicator>
  </div>
</div>
